(()=>{'use strict';
let pending=false;
const english=document.documentElement.lang.toLowerCase().startsWith('en');
const accountPage=(english?'/en':'')+'/pages/contact?view=corner-mypage';
async function pageHTML(){const r=await fetch(accountPage,{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('page');return r.text();}
// Begin the same account read alongside the coupon read, before Oxi creates its overlay.
let firstPage=(!english&&window.CornerWalletEarly?.accountPromise)||(document.querySelector('[data-corner-wallet-bootstrap]')?pageHTML().catch(()=>null):null);
async function attach(){
 const overlay=document.getElementById('oxi-ad-overlay'),modal=document.getElementById('oxi-ad-modal');
 if(!overlay||!modal||modal.dataset.cornerMypage||modal.dataset.cornerAttempt||pending)return;
 pending=true;modal.dataset.cornerAttempt='1';
 try{
  let html=firstPage?await firstPage:null;firstPage=null;if(html===null)html=await pageHTML();
  const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('[data-corner-mypage]');if(!root)throw Error('template');
  const data=JSON.parse(root.querySelector('[data-mypage-data]').textContent);if(!data.customer)return;
  // Load every page before exposing global status counts; never present a partial count.
  const total=Number(data.ordersCount)||0;
  for(let page=2;data.orders.length<total;page++){
   if(page>100)throw Error('order pagination limit');
   const response=await fetch(accountPage+'&page='+page,{credentials:'same-origin',cache:'no-store'});
   if(!response.ok)throw Error('orders');
   const pageDoc=new DOMParser().parseFromString(await response.text(),'text/html');
   const next=JSON.parse(pageDoc.querySelector('[data-mypage-data]').textContent);
   const known=new Set(data.orders.map(o=>o.name));const added=next.orders.filter(o=>!known.has(o.name));
   if(!next.customer||!data.customerId||next.customerId!==data.customerId||!added.length)throw Error('incomplete orders');
   data.orders.push(...added);
  }
  root.querySelector('[data-mypage-data]').textContent=JSON.stringify(data);
  root.querySelectorAll('a').forEach(a=>a.setAttribute('data-osl-external','true'));
  const existingClose=document.getElementById('oxi-ad-close');
  const nativeNav=tab=>modal.querySelector('#oxi-ad-nav [data-tab="'+tab+'"]');
  const host=document.createElement('div');host.className='corner-account-home';host.append(root);modal.prepend(host);
  // Rendering removes the clicked node; stop the app's outside-click handler seeing it as outside.
  root.addEventListener('click',e=>e.stopPropagation());
  function showNative(tab,edit=false){
   const node=nativeNav(tab);if(!node)return;
   modal.dataset.cornerNative=tab;node.click();
   if(edit)document.getElementById('oxi-ad-edit-profile-btn')?.click();
  }
  // The app moves its close button into the hidden sidebar on mobile.
  const close=document.createElement('button');close.type='button';close.className='corner-native-close';close.setAttribute('aria-label',english?'Close':'閉じる');close.textContent='×';close.onclick=()=>existingClose.click();
  document.getElementById('oxi-ad-content-header').append(close);
  const back=document.createElement('button');back.type='button';back.className='corner-native-back';back.textContent=english?'〈 My account':'〈 マイページ';back.onclick=async()=>{
   delete modal.dataset.cornerNative;
   try{
    const fresh=await fetch(accountPage,{credentials:'same-origin',cache:'no-store'});
    if(!fresh.ok)throw Error('refresh');
    const doc=new DOMParser().parseFromString(await fresh.text(),'text/html');
    const updated=JSON.parse(doc.querySelector('[data-mypage-data]').textContent);
    if(!updated.customer){existingClose.click();return;}
    root.dispatchEvent(new CustomEvent('corner:mypage:data',{detail:{customer:updated.customer,cartCount:updated.cartCount}}));
   }catch{const p=document.createElement('p');p.className='cmp-error';p.setAttribute('role','status');p.textContent=english?'We could not refresh your details. Please reload this page.':'最新情報を取得できませんでした。ページを再読み込みしてご確認ください。';root.querySelector('[data-body]').prepend(p);}
  };
  document.getElementById('oxi-ad-content-header').prepend(back);
  root.addEventListener('click',e=>{
   const a=e.target.closest('a');if(!a)return;
   if(a.closest('.cmp-head')){e.preventDefault();e.stopImmediatePropagation();existingClose.click();return;}
   const section=a.closest('.cmp-profile-section');
   if(section&&a.classList.contains('cmp-text-action')&&Array.from(root.querySelectorAll('.cmp-profile-section')).indexOf(section)<2){
    e.preventDefault();e.stopImmediatePropagation();const groups=Array.from(root.querySelectorAll('.cmp-profile-section'));
    showNative(groups.indexOf(section)===1?'addrs':'profile',groups.indexOf(section)===0);return;
   }
  },true);
  modal.dataset.cornerMypage='ready';overlay.setAttribute('aria-label',english?'My account':'マイページ');
  document.dispatchEvent(new CustomEvent('corner:mypage:mount',{detail:{root}}));
  let wasOpen=false;
  function syncOpen(){const open=overlay.classList.contains('oxi-ad-open');if(open===wasOpen)return;wasOpen=open;if(!open)delete modal.dataset.cornerNative;root.dispatchEvent(new CustomEvent(open?'corner:mypage:open':'corner:mypage:close'));}
  root.addEventListener('corner:mypage:history-close',()=>existingClose.click());
  root.addEventListener('corner:mypage:history-open',()=>{delete modal.dataset.cornerNative;if(!overlay.classList.contains('oxi-ad-open')){const entry=Array.from(document.querySelectorAll('a')).find(a=>!modal.contains(a)&&(a.href===new URL(data.urls.account,location.href).href||a.href.startsWith('https://account.corneronline.store')));entry?.click();}});
  new MutationObserver(syncOpen).observe(overlay,{attributes:true,attributeFilter:['class']});syncOpen();
 }catch(e){console.warn('CORNER account design could not load; original account remains available.');}
 finally{pending=false;}
}
const observer=new MutationObserver(()=>attach());observer.observe(document.documentElement,{childList:true,subtree:true});attach();
})();
